module.exports = __webpack_public_path__ + "static/2017-header-edcd9b1fee8a72f21a3d2d64ec9c81c0.jpg";